import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkiptestPopupComponent } from './skiptest-popup.component';
import { SharedModule } from '../../shared/shared.module';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';

@NgModule({
  declarations: [
    SkiptestPopupComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatInputModule,
    MatIconModule,
    MatDividerModule,
  ],
  exports: [
    SkiptestPopupComponent
  ]
})
export class SkiptestPopupModule { }
